export default __webpack_public_path__ + "static/media/tone-beep.4416fb71.mp3";